import { Fragment } from 'react'

import { Box } from '@telus-uds/components-web'
import ArticlePreview from './ArticlePreview'
import ArticleColumn from './ArticleColumn'
import { replaceWhitespaceLowercase } from '../../utils/manipulateString'
import { BlogUrl } from 'src/blogBuilder/utils/blogUrl'

import type { TypeArticleWithoutUnresolvableLinksResponse, TypeArticleFields } from '@/bb-contentful-types'
import { Language } from '@/siteBuilder/locale'
import { BlogContainer } from './styles'
import type { PreviewProps } from '.'

type Props = {
  listOfArticles: TypeArticleWithoutUnresolvableLinksResponse[]
  lang: Language
  displayCategory: boolean
  fullBlogUrls: BlogUrl
  theme: PreviewProps['theme']
  selectedCategory?: string
}

const Articles = ({ listOfArticles, lang, fullBlogUrls, theme, selectedCategory }: Props) => {
  const getFullURL = (slug: string): string => {
    const categorySelector = () => {
      if (selectedCategory?.toLowerCase() === 'all' || selectedCategory?.toLowerCase() === 'tout') {
        return ''
      }
      return `?category=${replaceWhitespaceLowercase(selectedCategory)}`
    }
    return `${slug}${categorySelector()}`
  }

  return (
    <BlogContainer>
      {listOfArticles &&
        listOfArticles
          .filter((d) => d)
          .map((article) => {
            return (
              <Fragment key={article?.sys?.id}>
                {theme === 'blog' ? (
                  <Box testID="bb-preview-card" vertical={3} horizontal={3}>
                    <ArticleColumn
                      fullBlogUrls={fullBlogUrls}
                      article={article.fields as TypeArticleWithoutUnresolvableLinksResponse['fields']}
                      lang={lang}
                      fullArticleUrl={getFullURL(
                        (article?.fields as TypeArticleWithoutUnresolvableLinksResponse['fields'])?.slug
                      )}
                    />
                  </Box>
                ) : (
                  <Box testID="bb-preview-card" vertical={3} horizontal={3}>
                    <ArticlePreview
                      article={article?.fields as TypeArticleWithoutUnresolvableLinksResponse['fields']}
                      fullBlogUrls={fullBlogUrls}
                      lang={lang}
                      fullArticleUrl={getFullURL(
                        (article?.fields as TypeArticleWithoutUnresolvableLinksResponse['fields'])?.slug
                      )}
                    />
                  </Box>
                )}
              </Fragment>
            )
          })}
    </BlogContainer>
  )
}

export default Articles
